import React from 'react';
import styles from './styles.css';
import { MFBeaconButton } from '../../Beacon/BeaconComponents';
import editIcon from '../../../images/icon_pencil.svg';
import { generateGeneralTestID } from '../../../generateAutomationTestIDs';

const EditButton = ({ onClick, currentlyEditing, disabled }) => (
  <span className="edit-button">
    <MFBeaconButton
      id="editButton"
      data-name={generateGeneralTestID('Review', 'EditButton')}
      disabled={disabled}
      type="button"
      onClick={onClick}
      className="override-beacon-button-padding"
      variant="tertiary"
      icon-align="left"
      label={currentlyEditing ? 'Done' : 'Edit'}>
      <img slot="icon" src={editIcon} alt="edit icon" />
    </MFBeaconButton>
    <style jsx>{styles}</style>
  </span>
);

EditButton.defaultProps = {
  text: '',
  disabled: false
};

export default EditButton;
